import * as Icons from './Icons'

const Icon = ({ icon, className }) => {
  // eslint-disable-next-line import/namespace
  return <img className={className} src={Icons[`Icon${icon}`]} />
}

export default Icon
